<template>
  <div id="page-user-list" class="vx-card p-6">
    <!--      Search area-->
    <vx-card
      ref="filterCard"
      @keyup.enter="pressEnterSearch"
      id="user_list_filters"
      tabindex="0"
      title=""
      class="user-list-filters mb-8"
      actionButtons
      @refresh="resetColFilters"
      @remove="resetColFilters"
    >
      <div class="vx-row">
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">お問い合わせ ﾊﾟﾀｰﾝ</label>
          <v-select
            class="w-full"
            id="mail_type_search"
            v-model="mail_type_search"
            :options="listMailTypeSelect"
            @input="clearFocusTypeDropdown()"
          >
            <span slot="no-options" class="text-xs"
              >すみません、マッチングオプションがありません。</span
            >
          </v-select>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">方法</label>
          <v-select
            class="w-full"
            id="inquiry_type_search"
            v-model="inquiry_type_search"
            :options="listInquiryTypeSelect"
            @input="clearFocusTypeDropdown()"
          >
            <span slot="no-options" class="text-xs"
              >すみません、マッチングオプションがありません。</span
            >
          </v-select>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">送信日時</label>
          <flat-pickr
            id="sent_date_search"
            class="w-full flatpickr-style"
            v-model="sent_date_search"
            placeholder="..."
            :config="configDate"
            @on-change="clearFocusTypeDropdown()"
          >
          </flat-pickr>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">お問い合わせID</label>
          <vs-input
            class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
            id="receive_mail_id_search"
            v-model="receive_mail_id_search"
            icon-after="true" :icon="receive_mail_id_search ? iconVsInput : ''"
          >
          </vs-input>
        </div>

        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">担当者</label>
          <v-select
            class="w-full"
            id="mst_user_search"
            v-model="mst_user_search"
            :options="listMstUserSelect"
            @input="clearFocusTypeDropdown()"
          >
            <span slot="no-options" class="text-xs"
              >すみません、マッチングオプションがありません。</span
            >
          </v-select>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">状態</label>
          <v-select
            class="w-full"
            id="state_flg_search"
            v-model="state_flg_search"
            :options="listSendMailSelectStateFlag"
            @input="clearFocusTypeDropdown()"
          >
            <span slot="no-options" class="text-xs"
              >すみません、マッチングオプションがありません。</span
            >
          </v-select>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">種別</label>
          <v-select
            class="w-full"
            id="type_search"
            v-model="type_search"
            :options="listTypeSelect"
            @input="clearFocusTypeDropdown()"
          >
            <span slot="no-options" class="text-xs"
              >すみません、マッチングオプションがありません。</span
            >
          </v-select>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full">
          <label class="text-sm opacity-75">タイトル</label>
          <vs-input
            class="mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4"
            id="subject_search"
            v-model="subject_search"
            icon-after="true" :icon="subject_search ? iconVsInput : ''"
          >
          </vs-input>
        </div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full"></div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full"></div>
        <div class="vx-col lg:w-1/4 sm:w-1/2 w-full"></div>
        <div
          class="
            vx-col
            flex flex-wrap
            justify-end
            m-auto
            mb-0
            pt-2
            lg:w-1/4
            sm:w-1/2
            w-full
          "
        >
          <vs-button icon="assignment" :disabled="readOnly" @click="onSendReport" color="success"
            >新規作成</vs-button
          >
          <vs-button
            icon="search"
            @click="onSearch(true)"
            color="primary"
            class="ml-2"
            >検索
          </vs-button>
        </div>
      </div>
    </vx-card>
    <div class="flex flex-wrap items-center">
      <vs-row class="pb-2"
              style="align-items: center; justify-content: space-between;"
              vs-type="flex">
        <vs-col vs-w="4" class="flex items-center">
          <vs-col style="width: 111px" class="mr-3">
            <vs-switch v-model="modeComputed">
              <span slot="on">プレビュー</span>
              <span slot="off">プレビュー非表示</span>
            </vs-switch>
          </vs-col>
          <vs-col style="width: 200px" class="flex items-center justify-center">
            <div style="width: 35%;">
              表示件数:
            </div>
            <div style="width: 60%">
              <v-select class="square mr-2"
                        id="pagination_limit"
                        v-model="pagination.limit"
                        placeholder="..."
                        :options="listRowLimit"
                        :searchable="false">
              </v-select>
            </div>
          </vs-col>
        </vs-col>
        <vs-col vs-w="8"
                vs-type="flex"
                vs-align="flex-end"
                vs-justify="flex-end">
          <vs-button class="square mr-2"
                      icon="delete"
                      color="danger"
                      @click="activeDeletePopUp = true"
                      :disabled="listMailDraftSelect.length == 0 || readOnly"
                      >
            <span>一括削除</span>
          </vs-button>

        </vs-col>
      </vs-row>
    </div>
    <!-- AgGrid Table -->
    <div v-if="!modeComputed">
      <ag-grid-vue
        id="myGrid"
        ref="agGridTable"
        :components="components"
        :gridOptions="gridOptions"
        class="ag-theme-material w-100 my-4 ag-grid-table database ag-grid-customize table-draft"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :rowData="listMailDraft"
        rowSelection="multiple"
        colResizeDefault="shift"
        :animateRows="true"
        :pagination="true"
        :domLayout="domLayout"
        :paginationPageSize="paginationPageSize"
        @sort-changed="onSortChanged"
        @grid-ready="onGridReady"
        @row-selected="rowClickChanged"
        :enableRtl="$vs.rtl"
        :overlayNoRowsTemplate="noRowsTemplate"
        :suppressPaginationPanel="true"
        :detailRowAutoHeight="true"
      >
      </ag-grid-vue>
      <div style="position: relative">
      <!-- ITEMS PER PAGE -->
      <div>
        <div class="flex items-center justify-between">
          <span class="pl-2 mr-2" style="font: 400 13.3333px Arial"
            >{{ totalRow }} 件中 {{ startRow }} 件から
            {{ endRow }} 件までを表示</span
          >
        </div>
      </div>
      <vs-pagination
        v-if="listMailDraft.length > 0"
        :total="pagination.totalPage"
        :max="7"
        v-model="pagination.currentPage"
        class="pt-10 pr-10"
      />
      </div>
    </div>
    <!--Preview mode-->
    <vs-row v-else vs-type="flex" vs-justify="space-between">
      <vs-col vs-w="4">
        <ag-grid-vue
            ref="agGridTable"
            :components="components"
            :gridOptions="gridOptionsPreview"
            class="ag-theme-material w-100 my-4 ag-grid-table database overflow-y-auto ag-grid-customize"
            :columnDefs="previewModeColumnDefs"
            :defaultColDef="defaultColDef"
            :rowData="listMailDraft"
            rowSelection="single"
            colResizeDefault="shift"
            :animateRows="true"
            :pagination="true"
            :domLayout="domLayout"
            :paginationPageSize="paginationPageSize"
            :isRowSelectable="() => true"
            @sort-changed="onSortChanged"
            @grid-ready="onGridReady"
            @selection-changed="onPreviewModeSelectionChanged"
            :enableRtl="$vs.rtl"
            :overlayNoRowsTemplate="noRowsTemplate"
            :suppressPaginationPanel="true"
            :detailRowAutoHeight="true"
            :getRowHeight="getRowHeight"
            :isFullWidthCell="isFullWidthCell"
            :fullWidthCellRenderer="fullWidthCellRenderer"
            style="max-height: 985px;"
            >
        </ag-grid-vue>

        <div style="position: relative">
          <!-- ITEMS PER PAGE -->
            <div>
                <div class="flex items-center justify-between">
                  <span class="pl-2 mr-2" style="font: 400 13.3333px Arial">{{ totalRow }} 件中 {{ startRow }} 件から {{ endRow }} 件までを表示</span>
                </div>
            </div>
            <vs-pagination
              v-if="listMailDraft.length > 0"
              :total="pagination.totalPage"
              :max="7"
              v-model="pagination.currentPage"
              class="pt-10 pr-10"
            />
        </div>
      </vs-col>

      <!--Preview section-->
      <vs-col vs-w="7.75" id="receive-mail-detail" >
        <vs-row class="mt-5  py-2"
                vs-type="flex"
                vs-align="flex-end"
                vs-justify="flex-end">
              <vs-button class="square"
                    color="#4478b8"
                    @click="editMailDetail(preview_detail)"
                    :disabled="!preview_detail.id"
                    >
                <span><feather-icon icon="EditIcon" class="cursor-pointer" svg-classes="h-6 w-6"></feather-icon></span>
              </vs-button>
        </vs-row>
        <vs-row>
          <vs-col>
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>方法</span>
                  </div>
                </template>
                <vs-input readonly class="disabled-input" v-model="preview_detail.inquiry_type_text" placeholder="" />
              </vx-input-group>
          </vs-col>
          <vs-col>
              <vx-input-group class ="square" type="file">
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>種別</span>
                  </div>
                </template>
                <vs-input readonly class="disabled-input" v-model="preview_detail.type_text" placeholder="" />
              </vx-input-group>
            </vs-col>
          <vs-col>
              <vx-input-group class ="square" type="file">
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>担当者</span>
                  </div>
                </template>
                <vs-input readonly class="disabled-input" v-model="preview_detail.mst_user" placeholder="" />
              </vx-input-group>
            </vs-col>
          <vs-col>
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>From</span>
                  </div>
                </template>

                <vs-input readonly class="disabled-input" v-model="preview_detail.email_sender" placeholder="" />
              </vx-input-group> 
            </vs-col>
          <vs-col>
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>To</span>
                  </div>
                </template>

                <vs-input readonly class="disabled-input" v-model="preview_detail.to" />
              </vx-input-group> 
          </vs-col>
          <vs-col>
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>CC</span>
                  </div>
                </template>

                <vs-input readonly class="disabled-input" v-model="preview_detail.cc" />
              </vx-input-group> 
          </vs-col>
          <vs-col>
              <vx-input-group>
                <template slot="prepend">
                  <div class="prepend-text label-style">
                    <span>BCC</span>
                  </div>
                </template>

                <vs-input readonly class="disabled-input" v-model="preview_detail.bcc" />
              </vx-input-group> 
          </vs-col>
          <vs-col class="mt-5" style="border: solid 1px #E2E2E2">
            <vx-input-group>
              <template slot="prepend">
                <div class="prepend-text label-style" style="width: 120px">
                  <span>添付ファイル</span>
                </div>
              </template>
              <vs-row>
                <vs-col
                  style="width: max-content; padding: 3px 5px"
                  :key="index"
                  v-for="(value, index) in preview_detail.attachmentFileName"
                >
                  <div @click="downloadAttachment(value.path)">
                    <vs-chip
                      style="cursor: pointer"
                      class="mt-1"
                      color="dark"
                      transparent
                      >{{ value.file_name }}</vs-chip
                    >
                  </div>
                </vs-col>
              </vs-row>
            </vx-input-group>
          </vs-col>
        </vs-row>

        <vs-row class="mt-6">
          <vx-card
            class="card-body-mail disabled-input"
            no-radius
            cardBorder
            noShadow
            title="件名"
          >
            <div
              class="w-full"
              v-html="preview_detail.subject"
              style="padding: 9.8px"
            ></div>
          </vx-card>

          <vx-card
            class="card-body-mail disabled-input"
            no-radius
            cardBorder
            noShadow
            title="お問い合わせ本文"
          >
            <div
              id="previewDetailBodyBlock"
              class="pl-2 pt-2"
              v-if="!preview_detail.body_type || preview_detail.body_type == 0"
              v-html="cleanedBodyPreviewDetail"
              style="height: 560px; overflow-y: scroll"
            ></div>
            <vs-textarea
              id="previewDetailBodyTextarea"
              v-else
              readonly
              v-model="preview_detail.body"
              placeholder="..."
              height="560px"
            />
          </vx-card>
        </vs-row>
      </vs-col>
    </vs-row>

    <!-- dialog confirm delete-->
    <vs-popup ref="dialogConfirm" title="下書きを削除" :active.sync="activeDeletePopUp" button-close-hidden>
        <div>
          <span>
            選択した下書きを削除しますか？
          </span>
        </div>
        <div class="flex justify-end">
            <vs-button @click="deleteSelect" color="danger" icon="delete" style="padding: 8px; margin-right: 5px;height: 37px">はい</vs-button>
            <vs-button @click="activeDeletePopUp = false" color="lightgrey" icon="cancel" style="padding: 8px; margin-right: 5px;height: 37px">閉じる</vs-button>
        </div>
      </vs-popup>
  </div>
</template>
<script>
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import { AgGridVue } from "ag-grid-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";
import { mapActions, mapGetters, mapMutations } from "vuex";
import CellRendererActions from "@/components/cell-renderer/CellRendererActions";
import CellRendererCheckbox from "@/components/cell-renderer/CellRendererCheckbox";
import EventBus from "../EventBus";
import {convertInquiryTypeToText, convertMailTypeToText, handleDownloadAttachment, setupIconClickEvent, convertLineBreakBody} from "@/utils/helpler-utils";

export default {
  components: {
    AgGridVue,
    vSelect,
    flatPickr,
    CellRendererActions,
    CellRendererCheckbox,
  },
  data() {
    return {
      iconVsInput:'close',
      readOnly: false,
      isCreated: true,
      activeConfirm: false,
      sent_date_search: "",
      mail_type_search: {
        label: "...",
        value: "",
      },
      response_date_search: "",
      receive_mail_id_search: "",
      mst_user_search: {
        value: "",
        label: "...",
      },
      state_flg_search: {
        value: "",
        label: "...",
      },
      inquiry_type_search: {
        value: "",
        label: "...",
      },
      subject_search: "",
      type_search: {
        value: "",
        label: "...",
      },
      configDate: {
        locale: Japanese,
        wrap: true,
        defaultHour: 0,
        maxDate: "",
      },
      listSentUserNameSelect: ["..."],
      listMstUserSelect: [
        {
          label: "...",
          value: "",
        },
      ],
      listMailTypeSelect: [
        {
          label: "...",
          value: "",
        },
        {
          label: "直接お問い合わせ",
          value: "0",
        },
        {
          label: "返信メール",
          value: "1",
        },
      ],
      listInquiryTypeSelect: [
        {
          label: "...",
          value: "",
        },
        {
          label: "メール",
          value: "0",
        },
        {
          label: "電話",
          value: "1",
        },
        {
          label: "営業",
          value: "2",
        },
        {
          label: "その他",
          value: "9",
        },
      ],
      listMailReceiveSelect: [],
      listSendMailSelectStateFlag: [
        {
          label: "...",
          value: "",
        },
        {
          value: 0,
          label: "下書き",
        },
        {
          value: 1,
          label: "送信済",
        },
        {
          value: 2,
          label: "送信失敗",
        },
      ],
      listTypeSelect: ["..."],

      startRow: 0,
      endRow: 0,
      pagination: {
        totalPage: 0,
        currentPage:
          this.searchFilter &&
          this.searchFilter.queries &&
          this.searchFilter.queries.page
            ? this.searchFilter.queries.page
            : 1,
        limit: 10,
        totalItem: 0,
        from: 1,
        to: 10,
      },
      orderBy: "id",
      orderDir: "desc",

      // AgGrid
      noRowsTemplate: "<span>データがありません</span>",
      domLayout: "autoHeight",
      gridApi: null,
      columnApi: null,
      isRowSelectable: null,
      gridOptions: {
        onGridSizeChanged: () => {
          this.gridApi.sizeColumnsToFit();
        },
        onCellClicked: (cell) => {
          if (cell.value !== undefined){
            this.editMailDetail(cell.data, false)
          }
        },
        suppressRowClickSelection: true,
      },
      gridOptionsPreview: {
        onGridSizeChanged: () => {
          this.gridApi.sizeColumnsToFit();
        },
      },
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true,
        sortingOrder: ["asc", "desc"],
      },
      columnDefs: [
        {
          width: 50,
          filter: true,
          checkboxSelection: (params) => {
            return true;
          },
          headerCheckboxSelectionFilteredOnly: true,
          headerCheckboxSelection: true,
          suppressMovable: true,
          // resizable: false
        },
        {
          headerName: "方法",
          field: "inquiry_type_text",
          width: 75,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "送信日時",
          field: "sent_datetime",
          width: 150,
          unSortIcon: true,
          sort: "desc",
          suppressMovable: true,
        },
        {
          headerName: "お問い合わせID",
          field: "receive_mail_id",
          width: 325,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "担当者",
          field: "full_name",
          width: 150,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "状態",
          field: "state_flg_text",
          width: 130,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "種別",
          field: "type_text",
          width: 100,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "タイトル",
          field: "subject",
          width: 300,
          unSortIcon: true,
          suppressMovable: true,
        },
        {
          headerName: "",
          field: "transactions",
          width: 100,
          cellRendererFramework: "CellRendererActions",
          cellRendererParams: {
            hideEdit: true,
            hideDelete: false,
          },
          unSortIcon: false,
          suppressMovable: true,
          resizable: true,
        },
      ],

      removeID: [],

      // Cell Renderer Components
      components: {
        CellRendererActions,
      },
      //Preview Mode
      previewModeColumnDefs: [
        {
          headerName: "",
          field: "id",
          width: 200,
          unSortIcon: true,
          suppressMovable: true,
        },
      ],
      getRowHeight: null,
      fullWidthCellRenderer: null,
      isFullWidthCell: null,
      selectedPreviewMail: {},
      listMailDraftSelect: [],
      activeDeletePopUp: false,

      //PAC_21-91
      listRowLimit: [
        '10',
        '25',
        '50'
      ]
    };
  },
  watch: {
    'pagination.limit': function () {
      this.pagination.currentPage = 1;
      this.onSearch(false);
    },
    async $route(to, from) {
      /* start loading with many requests */
      this.$store.dispatch("updateLoads", true);
      this.clearSearchFilter();
      this.listMailDraftSelect = [];
      this.removeID = [];
      let mailBox = this.$route.params.email;
      if (mailBox) {
      } else if (this.listMailBox && this.listMailBox.length > 0) {
        mailBox = this.listMailBox[0].receive_user_name;
      }
      if (mailBox) {
        this.setDefaultSearchOption();
        this.orderBy = "id";
        this.orderDir = "desc";
        this.gridApi.setSortModel({ colId: "id", sort: "desc" });
        await this.getListMstUserSelect();
        await this.getListMailBox();
        await this.getListKindsSelect();
        await this.onSearch(true, mailBox);
      }

      /* stop loads */
      this.$store.dispatch("updateLoads", false);
    },
    inquiry_id_search(val) {
      if (val < 0) return (this.inquiry_id_search = null);
    },
    "pagination.currentPage": {
      deep: true,
      immediate: true,
      handler: function (val) {
        if (!this.isCreated) this.paginationPage(val);
      },
    },
    activeDeletePopUp() {
      if (!this.activeDeletePopUp) {
        this.removeID = [];
      }
    }
  },
  beforeMount() {
    this.isRowSelectable = (params) => {
      return true;
    };
    this.isFullWidthCell = (rowNode) => {
        if (this.mode == true) {
          return rowNode.data;
        }
    },
    this.fullWidthCellRenderer = (params) => {
        let to = params.data.to ? params.data.to.split(",") : null;
        if (to && to.length > 1) to = to[0] + ', ...';
        else if (to && to.length == 1) to = params.data.to;
        else to = '';
        let date = params.data.update_at || params.data.create_at;
        let subject = params.data.subject || "";

        let cellClass = "cell-full-width ";
        const eDiv = document.createElement("div");
        eDiv.innerHTML = `<div class=${cellClass}>
          <div class="mail-header">
            <span>${to}</span>
            <span>${date}</span>
          </div>
          <br><span style="font-size:15px; line-height: 1.5">${subject}</span></div>
        </div>`;
        return eDiv.firstChild;
    };
    this.getRowHeight = () => {
      if (this.mode == true) {
        return 85;
      } else {
        return 50;
      }
    };
  },
  computed: {
    ...mapGetters({
      listMailBox: "receiveMail/listMailBox",
      currentMailBoxSelected: "receiveMail/currentMailBoxSelected",
      listMailDraft: "mailDraft/listMailDraft",
      searchFilter: "mailDraft/getSearchFilter",
      preMailDraft: "mailDraft/preMailDraft",
      mode: "mailDraft/mode",
    }),
    paginationPageSize() {
      // if (this.gridApi) return this.gridApi.paginationGetPageSize();
      // else return 10;
      return this.pagination.limit
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    totalRow() {
      return parseInt(this.pagination.totalItem);
    },
    preview_detail() {
      return this.selectedPreviewMail ? this.selectedPreviewMail : {};
    },
    modeComputed: {
      get() {
        return this.mode;
      },
      async set() {
        await this.setMode();
      },
    },
    cleanedBodyPreviewDetail() {
        return convertLineBreakBody(this.preview_detail.body);
    },
  },
  methods: {
    ...mapActions({
      getListUserDataSelect: "receiveMail/getListUserDataSelect",
      getListMailServerSentUser: "receiveMail/getListMailServerSentUser",
      getListMailBox: "receiveMail/getListMailBox",
      getListKinds: "kinds/getListKinds",
      getListMailDraft: "mailDraft/getListMailDraft",
      clearSearchFilter: "mailDraft/clearSearchFilter",
      clearSearchFilterReceive: "receiveMail/clearSearchFilter",
      removeDraft: "mailDraft/deleteMailDraft",
      setMode: "mailDraft/setMode",
      getSelectedMailPreviewMode: "moduleEmail/getSelectedMailPreviewMode",
      downloadFile: "receiveMail/downloadAttachment",
      setUserReadOnly: "receiveMail/setUserReadOnly",
    }),
    ...mapMutations({
      setSearchFilter: "mailDraft/SET_SEARCH_FILTER",
    }),
    clearInput(modelExpression) {
      this[modelExpression] = ""; // Clear the value input
    },
    pressEnterSearch() {
      this.onSearch(true)
    },
    clearFocusTypeDropdown() {
      this.$nextTick(() => {
        document.activeElement.blur()
        document.getElementById('user_list_filters').focus()
      })
    },
    async paginationPage(value) {
      if (!this.isCreated) {
        this.pagination.currentPage = value;
        let mailBox = this.$route.params.email;
        if (mailBox) {
        } else if (this.listMailBox && this.listMailBox.length > 0) {
          mailBox = this.listMailBox[0].receive_user_name;
        }
        await this.onSearch(false, mailBox);
      }
    },
    rowClickChanged(event) {
      //Check row is selected
      let selected = event.node.selected;
      if (selected) {
        this.listMailDraftSelect.push(event.data.id);
      } else {
        this.listMailDraftSelect = this.listMailDraftSelect.filter(id => id != event.data.id)
      }
    },
    onSortChanged(event) {
      let columns = event.columnApi.getAllColumns();
      let root = this;
      columns.forEach(function (column) {
        if (column.getSort()) {
          root.orderDir = column.getSort();
          root.orderBy = column.getColId();
          root.onSearch(false);
        }
      });
    },
    updateSortParams(orderBy, orderDir) {
      this.orderBy = orderBy;
      this.orderDir = orderDir;
    },
    async getListMstUserSelect() {
      let mailBoxInfo = await this.listMailBox.find(
        (element) => element.receive_user_name == this.currentMailBoxSelected
      );
      if (mailBoxInfo) {
        let params = {
          mst_mail_server_id: mailBoxInfo.id,
        };
        let response = await this.getListUserDataSelect(params);
        if (response) {
          this.listMstUserSelect = [
            {
              label: "...",
              value: "",
            },
          ];
          response.map((element) => {
            let result = {};
            result.value = element.id;
            result.label = element.full_name;
            this.listMstUserSelect.push(result);
          });
        } else {
          this.listMstUserSelect = [
            {
              label: "...",
              value: "",
            },
          ];
        }
      }
    },
    onSendReport() {
      // this.$router.push(`/sent/${this.currentMailBoxSelected}/create-mail`);
      let routePath = `/sent/${this.currentMailBoxSelected}/create-mail?back=true`;
       window.open(routePath, '_blank');
    },
    async onSearch(resetPaging, mailBox = null) {
      let mst_user_id = "";
      if (this.mst_user_search) {
        mst_user_id = this.mst_user_search.value;
      }
      let state_flg = "";
      if (this.state_flg_search) {
        state_flg = this.state_flg_search.value;
      }
      let mail_type = "";
      if (this.mail_type_search) {
        mail_type = this.mail_type_search.value;
      }
      let inquiry_type = "";
      if (this.inquiry_type_search) {
        inquiry_type = this.inquiry_type_search.value;
      }
      let type = "";
      if (this.type_search) {
        type = this.type_search.value;
      }
      let action = "";
      if (resetPaging === true && mailBox === null) {
        action = "search";
      }
      if (mailBox === null) {
        mailBox = this.currentMailBoxSelected;
      } else {
        this.$store.commit("receiveMail/SET_CURRENT_MAIL_BOX_SELECT", mailBox);
      }
      // process order by
      if (this.orderBy) {
        if (this.orderBy === "state_flg_text") {
          this.orderBy = "state_flg";
        }
        if (this.orderBy === "inquiry_type_text") {
          this.orderBy = "inquiry_type";
        }
        if (this.orderBy === "type_text") {
          this.orderBy = "type";
        }
      }
      let page = this.pagination.currentPage;
      if (resetPaging === true) page = 1;
      if (this.isCreated)
        page =
          this.searchFilter && this.searchFilter.mailBox === mailBox
            ? this.searchFilter.queries.page
            : 1;
      let params = {
        mailBox: mailBox,
        queries: {
          inquiry_type: inquiry_type,
          sent_datetime: this.sent_date_search,
          mail_type: mail_type,
          // response_limit: this.response_date_search,
          receive_mail_id: this.receive_mail_id_search,
          mst_user_id: mst_user_id,
          // receive_mail_email_sender: this.receive_mail__email_sender_search,
          // state_flg_receive_mail: state_flg_receive_mail,
          state_flg: state_flg,
          subject: this.subject_search,
          type: type,
          action: action,
          page: page,
          limit: this.pagination.limit,
          orderBy: this.orderBy,
          orderDir: this.orderDir,
        },
      };
      let data = await this.getListMailDraft(params);
      this.handleMailSelected();
      this.setSearchFilter(params);

      this.pagination.totalItem = data.total;
      this.pagination.totalPage = data.last_page;
      this.pagination.currentPage = data.current_page;
      this.pagination.limit = data.per_page;
      this.pagination.from = data.from;
      this.pagination.to = data.to;

      //Load preview mode
      if (this.mode) this.loadPreview();
    },
    clearSearchOption() {
      this.mail_type_search = "";
      this.clearSearchCommon();
    },
    setDefaultSearchOption() {
      this.mail_type_search = {
        label: "直接お問い合わせ",
        value: "0",
      };
      this.clearSearchCommon();
    },
    clearSearchCommon() {
      this.sent_date_search = "";
      this.response_date_search = "";
      this.receive_mail_id_search = "";
      this.inquiry_id_search = "";
      this.mst_user_search = "";

      this.inquiry_type_search = {
        value: "",
        label: "...",
      };
      this.state_flg_search = {
        value: "",
        label: "...",
      };
      this.type_search = {
        value: "",
        label: "...",
      };
      this.subject_search = "";
    },
    async getListKindsSelect() {
      let response = await this.getListKinds();
      if (response) {
        this.listTypeSelect = [
          {
            label: "...",
            value: "",
          },
        ];
        response.map((element) => {
          let result = {};
          result.value = element.type_id;
          result.label = element.kinds_name;
          this.listTypeSelect.push(result);
        });
      } else {
        this.listTypeSelect = [
          {
            label: "...",
            value: "",
          },
        ];
      }
    },
    async resetColFilters() {
      // Reset Grid Filter
      this.gridApi.setFilterModel(null);
      this.gridApi.onFilterChanged();
      this.clearSearchFilter();
      this.clearSearchOption();
      await this.onSearch(true);
      this.$refs.filterCard.removeRefreshAnimation();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      if (this.mode) {
        this.loadPreview();
      }
    },
    mailBoxSelectable() {
      let mailBox = this.listMailBox.find(
        (item) => item.receive_user_name === this.$route.params.email
      );
      if (!mailBox.numberMailNotSupport)
        document.getElementsByClassName(
          "ag-header-select-all ag-labeled ag-label-align-right ag-checkbox"
        )[0].style.opacity = "0.5";
      else
        document.getElementsByClassName(
          "ag-header-select-all ag-labeled ag-label-align-right ag-checkbox"
        )[0].style.opacity = "1";
    },
    async deleteSelect () {
      let ids = this.removeID;
      if (this.removeID.length == 0) {
        //Batch Delete
        ids = this.listMailDraftSelect;
        this.listMailDraftSelect = [];
      }
      this.removeID = [];
      let params = {
        mailBox: this.$route.params.email,
        id : ids
      }
      await this.removeDraft(params)
      this.activeDeletePopUp = false;
      await this.onSearch(false)
    },
    async refreshPage() {
      if (localStorage.refreshPage) {
        if (localStorage.refreshPage == 'draft'){
          localStorage.removeItem("refreshPage");
          let mailBox = this.$route.params.email;
          if (mailBox) {
            this.orderBy = "id";
            this.orderDir = "desc";
            await this.sleep(1500);
            await this.onSearch(false, mailBox);
          } 
        } else{
          localStorage.removeItem("refreshPage");
        }
      }
    },
    async sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    async onPreviewModeSelectionChanged() {
      let selectedRows = this.gridApi.getSelectedRows();
      let params = {
        mailBox: this.$route.params.email,
        id: selectedRows[0].id,
        type: 1,
        full_name: selectedRows[0].full_name
      }
      this.selectedPreviewMail = await this.getSelectedPreviewMail(params);
      if(this.preview_detail.body_type) {
        const topScrollElement = document.getElementById('previewDetailBodyTextarea')
        topScrollElement.scrollTop = 0;
      }
      else {
        const topScrollElement = document.getElementById('previewDetailBodyBlock')
        topScrollElement.scrollTop = 0;
      }
    },
    async getSelectedPreviewMail(params) {
      let selectedPreviewMail = await this.getSelectedMailPreviewMode(params);
      selectedPreviewMail.inquiry_type_text = convertInquiryTypeToText(selectedPreviewMail.inquiry_type)
      selectedPreviewMail.type_text = convertMailTypeToText(null, selectedPreviewMail.kinds_name, selectedPreviewMail.kinds_state)
      selectedPreviewMail.mst_user = params.full_name
      selectedPreviewMail.attachmentFileName = [];
      if (selectedPreviewMail.attachment_filepath){
        let listattachmentFiles = selectedPreviewMail.attachment_filepath.split(',')
        listattachmentFiles.forEach((element)=>{
        selectedPreviewMail.attachmentFileName.push({
            path: element,
            file_name: element.split('/').reverse()[0]
          })
        });
      }
      return selectedPreviewMail;
    },
    loadPreview() {
      if (this.selectedPreviewMail) {
        let isNewPage = true;
        this.gridApi.forEachNode((node) => {
          isNewPage =
            this.selectedPreviewMail.id == node.data.id ? false : isNewPage;
          node.setSelected(
            this.selectedPreviewMail.id == node.data.id,
            true,
            true
          ); //Prevent call back to onPreviewModeSelectionChanged
        });
        //Set node[0] when direct to new page
        if (isNewPage && this.gridApi.getRowNode(0)) this.gridApi.getRowNode(0).setSelected(true);
        else if (this.listMailDraft && this.listMailDraft.length == 0) this.selectedPreviewMail = {};
      } else {
        this.gridApi.getRowNode(0).setSelected(true);
      }
    },
    async downloadAttachment(file) {
      let data = {
        "id" : this.preview_detail.id,
        "fileName" : file,
      }
      let result = await this.downloadFile(data);
      if (result) {
        handleDownloadAttachment(result);
      }
    },
    async editMailDetail(mail_detail, preview_mode = true) {
      const mail_id = mail_detail.id
      let params = {
        mailBox: this.$route.params.email,
        id: mail_id,
        type: 1,
        full_name: preview_mode ? mail_detail.mst_user : mail_detail.full_name
      }
      let mail = await this.getSelectedPreviewMail(params);
      if (mail) {
        let listPreMailDraft = this.preMailDraft
        listPreMailDraft = listPreMailDraft.filter(pre => pre.id != mail.id)
        listPreMailDraft.push(mail);
        this.$store.commit("mailDraft/SET_PREVIOUS_MAIL_DRAFT", listPreMailDraft);
        localStorage.setItem("enablePrevios", true)
        let viewDraftSend = mail.name_view_send == 'mailsend' ? '&name_view_send=true&':'';
        let routePath = `/draft/${this.$route.params.email}/${mail.id}?${mail.receive_inquiry_id ? 'receive-inquiry-id=' + mail.receive_inquiry_id + viewDraftSend + '&view-draft=true&' : ''}back=true`;
        window.open(routePath, '_blank');
      }
    },
    handleMailSelected(){
      this.gridApi.forEachNode(node => {
        //Check row id exist in list Selected
        let checkExist = this.listMailDraftSelect.filter(id => id == node.data.id).length == 0 ? false : true;
          if (checkExist) {
            node.setSelected(true);
          }
      });
    }
  },

  mounted() {
    this.gridApi = this.gridOptions.api;
    /* =================================================================
      NOTE:
      Header is not aligned properly in RTL version of agGrid table.
      However, we given fix to this issue. If you want more robust solution please contact them at gitHub
    ================================================================= */
    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left = `-${String(
        Number(header.style.transform.slice(11, -3)) + 9
      )}px`;
    }
    EventBus.$on("deleteRecord", (id) => {
      const root = this;
      this.removeID = [id];
      window.addEventListener("beforeunload", function () {
        sessionStorage.setItem("paginationPageSize", root.paginationPageSize);
      });
      this.activeDeletePopUp = true;
    });
    this.mailBoxSelectable();
    this.clearSearchFilterReceive();
    // addEventListener Reload => clear
    window.addEventListener("beforeunload", this.resetColFilters);
    window.addEventListener('storage', this.refreshPage);
    setupIconClickEvent();
  },
  async created() {
    /* start loading with many requests */
    this.$store.dispatch("updateLoads", true);

    let mailBox = this.$route.params.email;
    await this.getListMailBox();
    if (!mailBox) {
      if (this.listMailBox && this.listMailBox.length > 0) {
        mailBox = this.listMailBox[0].receive_user_name;
      }
    } else {
      if (
        this.listMailBox &&
        this.listMailBox.length > 0 &&
        this.listMailBox.find((mb) => mb.receive_user_name == mailBox)
      ) {
        //...
      } else mailBox = null;
    }
    await this.getListMstUserSelect();
    await this.getListKindsSelect();
    if (mailBox) {
      this.clearSearchFilter();
      if (
        this.searchFilter &&
        this.searchFilter.queries &&
        this.searchFilter.mailBox &&
        this.searchFilter.mailBox === mailBox
      ) {
        this.subject_search = this.searchFilter.queries.subject
          ? this.searchFilter.queries.subject
          : "";
        this.body_search = this.searchFilter.queries.body
          ? this.searchFilter.queries.body
          : "";
        this.mail_type_search = this.listMailTypeSelect.find(
          (type) => type.value === this.searchFilter.queries.mail_type
        );
        this.inquiry_type_search = this.listInquiryTypeSelect.find(
          (inquiry) => inquiry.value === this.searchFilter.queries.inquiry_type
        );
        this.mst_user_search = this.listMstUserSelect.find(
          (user) => user.value === this.searchFilter.queries.mst_user_id
        );
        this.email_sender_search = this.searchFilter.queries.email_sender
          ? this.searchFilter.queries.email_sender
          : "...";
        this.type_search = this.listTypeSelect.find(
          (type) => type.value === this.searchFilter.queries.type
        );
        this.state_flg_search = this.listSendMailSelectStateFlag.find(
          (state) => state.value === this.searchFilter.queries.state_flg
        );
        this.pagination.limit = this.searchFilter.queries.limit
          ? this.searchFilter.queries.limit
          : 10;
        this.sent_date_search = this.searchFilter.queries.sent_datetime
          ? this.searchFilter.queries.sent_datetime
          : "";
        this.orderBy = "id";
        this.orderDir = this.searchFilter.queries.orderDir
          ? this.searchFilter.queries.orderDir
          : "asc";
      }
      await this.onSearch(false, mailBox);
      this.isCreated = false;
    } else this.$router.push({ path: "/dashboard" });

    /* stop loads */
    this.readOnly = await this.setUserReadOnly(mailBox) > 0;
    this.$store.dispatch("updateLoads", false);
  },
  updated() {
    this.$nextTick(() => {
      if (!this.$store.state.loading && this.listMailDraft.length > 0) {
        this.startRow =
          this.pagination.currentPage * this.pagination.limit -
          this.pagination.limit +
          1;
        if (this.listMailDraft.length == this.pagination.limit)
          this.endRow = this.pagination.currentPage * this.pagination.limit;
        else
          this.endRow =
            this.pagination.limit * this.pagination.currentPage +
            this.listMailDraft.length -
            this.pagination.limit;
      } else if (this.listMailDraft.length == 0) {
        this.pagination.totalItem = 0;
        this.startRow = 0;
        this.endRow = 0;
      }
    });
    this.mailBoxSelectable();
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.resetColFilters, {
      passive: true,
    });
    EventBus.$off('deleteRecord');
    window.removeEventListener("storage", this.refreshPage)
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vuexy/components/view/mailBox.scss";
@import "@/assets/scss/vuexy/components/view/receivedMailDetail.scss";

.table-draft {
  .ag-cell, 
  .ag-header-cell {
    padding-inline: 10px !important;
  }
}
</style>
